// extracted by mini-css-extract-plugin
module.exports = {"container":"Company_container__1vk0_","title":"Company_title__ln6fV","subtitle":"Company_subtitle__38N4o","itemsWrapper":"Company_itemsWrapper__25olK"};